<div
  bsDropdown
  (click)="$event.stopPropagation()"
  class="gcc-select dropdown"
  [isDisabled]="disabled"
  [isOpen]="isOpen"
  (isOpenChange)="handleDropdownToggle($event)"
  #dropdown
>
  <button dropdownToggle type="button" class="form-control text-left dropdown-toggle d-flex align-items-center">
    <span class="placeholder flex-grow-1">{{ isOpen ? selectedQuantityLabel : selectedQuantityLabel }}</span>
  </button>

  <div *dropdownMenu class="dropdown-menu wrapper">
    @if (optionsData.length > 0) {
      @if (isSelectAllAvailable) {
        <div class="form-group custom-control custom-checkbox" [style.margin-left]="'13px'" (click)="toggleSelectAll()">
          <input
            type="checkbox"
            class="custom-control-input"
            [checked]="selectedOptions.length === renderedOptions.length"
            [indeterminate]="selectedOptions.length !== renderedOptions.length && selectedOptions.length !== 0"
          />
          <label class="custom-control-label"> Select all </label>
        </div>
      }
      @for (option of optionsData; track option) {
        <gcc-option [value]="option.value">
          <div class="form-group custom-control custom-checkbox disable-actions">
            <input
              type="checkbox"
              class="custom-control-input"
              [id]="option.value"
              [checked]="selectedOptions.includes(option.value)"
            />
            <span class="custom-control-label"></span>
            <!--          <img *ngIf="option.iconSrc" [class]="option.iconClass" [src]="option.iconSrc" />-->
            <span class="checkbox-text">{{ option.label }}</span>
          </div>
        </gcc-option>
      }
      <div class="footer">
        <button (click)="onCancel()" class="btn btn-light btn-sm" type="button">
          {{ 'common.buttons.cancel' | translate }}
        </button>
        <button
          class="btn btn-primary ml-4 btn-sm"
          type="button"
          [disabled]="compareArrays(selectedOptions, bufferedSelectedOptions) || this.selectedOptions.length === 0"
          (click)="onApply()"
        >
          {{ 'common.buttons.apply' | translate }}
        </button>
      </div>
    } @else {
      <span style="margin-left: 12px">No available items</span>
    }
  </div>
</div>
